<template>
  <div class="wrapper order-wrapper order-confirm" :class="{ 'is-focus': isFocus }">
    <!-- 收货地址 -->
    <div
      class="section order-address"
      v-if="order.tradeInfo && order.tradeInfo.tradeType >= 100"
      @click="onAddress"
    >
      <div class="location-icon"></div>
      <div class="content">
        <template v-if="address && address.id">
          <h3>
            <span>{{address.name}}</span>
            <span>{{address.phone}}</span>
          </h3>
          <p>{{address.province}} {{address.city}} {{address.district}} {{address.address}}</p>
        </template>
        <h2 v-else>点此添加收货地址</h2>
      </div>
    </div>
    <!-- 商品 -->
    <section class="section goods" v-if="order.tradeItemList">
      <good-item v-for="item in order.tradeItemList" :data="item" :key="item.id"></good-item>
    </section>
    <!-- 优惠券 -->
    <coupon-cell :list="coupon" v-model="orderParam.userRelaCouponId" @change="couponChange"></coupon-cell>
    <!-- 售票表单 -->
    <section class="section" v-if="detail && detail.pickTickInfo">
      <div class="hd">
        <h2 class="title">{{detail.pickTickInfo.title}}：</h2>
      </div>
      <div class="bd">
        <div class="order-form">
          <template v-for="(item, index) in detail.pickTickInfo.inputs">
            <!-- input -->
            <div
              class="form-group"
              :key="`order_confirm_form_${index}`"
              v-if="item.inputType === 1"
            >
              <label class="title">{{item.keyName}}{{item.allowBlank === 0 ? '*' : ''}}</label>
              <input
                :type="item.verifyType === 1 ? 'tel': 'text'"
                class="form-controls"
                :placeholder="item.hint"
                v-model="form[item.key]"
                @focus="inputFocus"
                @blur="inputBlur"
              >
            </div>
            <!-- select -->
            <div
              class="form-group"
              :key="`order_confirm_form_${index}`"
              v-if="item.inputType === 2"
            >
              <label class="title">{{item.keyName}}{{item.allowBlank === 0 ? '*' : ''}}</label>
              <select
                dir="rtl"
                class="form-controls"
                :placeholder="item.hint"
                v-model="form[item.key]"
              >
                <option
                  :value="option.key"
                  v-for="option in item.values"
                  :key="option.key"
                >{{option.value}}</option>
              </select>
            </div>
            <!-- 地区 -->
            <div
              class="form-group"
              :key="`order_confirm_form_${index}`"
              v-if="item.inputType === 3"
            >
              <label class="title">{{item.keyName}}{{item.allowBlank === 0 ? '*' : ''}}</label>
              <div class="form-controls" @click="openPicker(item.key)">
                <template
                  v-if="form[item.key]"
                >{{`${form[item.key].province} ${form[item.key].city} ${form[item.key].district}`}}</template>
              </div>
              <!-- <input type="text" class="form-controls" :placeholder="item.hint" :value="`${form[item.key].province} ${form[item.key].city} ${form[item.key].district}`" @click="openPicker(item.key)" readonly disabled> -->
              <city-picker :ref="item.key" @confirm="onCityConfirm"></city-picker>
            </div>
            <!-- 日期 -->
            <div
              class="form-group"
              :key="`order_confirm_form_${index}`"
              v-if="item.inputType === 4"
            >
              <label class="title">{{item.keyName}}{{item.allowBlank === 0 ? '*' : ''}}</label>
              <div
                class="form-controls"
                @click="openPicker(item.key)"
              >{{formatDateTime(form[item.key])}}</div>
              <!-- <input type="text" class="form-controls" :placeholder="item.hint" :value="formatDateTime(form[item.key])" @click="openPicker(item.key)" readonly disabled> -->
              <mt-datetime-picker
                :ref="item.key"
                type="datetime"
                v-model="picker[item.key]"
                @confirm="onPickerConfirm"
                :startDate="startDate"
                :endDate="endDate"
              ></mt-datetime-picker>
            </div>
          </template>
          <div class="tips" v-html="getAutoWrapContent(detail.pickTickInfo.tip)"></div>
        </div>
      </div>
    </section>
    <!-- 订单列 -->
    <section class="section cell-list">
      <template v-for="(item, index) in list">
        <div class="cell" v-if="get(order, item.value) !== undefined" :key="index">
          <div class="title">{{item.label}}</div>
          <div class="content" :class="item.className">
            <template v-if="item.before">
              <span>{{item.before}}</span>
            </template>
            <template v-if="item.computed">
              <span>{{item.computed(get(order, item.value), order)}}</span>
            </template>
            <template v-else>
              <span>{{get(order, item.value)}}</span>
            </template>
            <template v-if="item.after">
              <span>{{item.after}}</span>
            </template>
          </div>
        </div>
      </template>
    </section>
    <!-- 订单提示 -->
    <div class="section" style="background-color:transparent;" v-if="detail.discountSubject">
      <div class="bd order-form">
        <div class="tips">{{detail.discountSubject}}</div>
      </div>
    </div>
    <div class="fixed-bar" v-if="order.tradeInfo">
      <div class="inner">
        <div
          class="buy-total"
          v-html="getPriceCreditHtml(order.tradeInfo.payAmount, order.tradeInfo.creditAmount, '合计')"
        ></div>
        <input
          type="button"
          class="btn btn-order-buy"
          value="确定"
          @click="onSubmit"
          :disabled="disabled"
        >
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash.get'
import {
  initTicketOrder,
  calculateTicketOrder,
  createTicketOrder,
  initShopOrder,
  calculateShopOrder,
  createShopOrder
} from '@/api/order'
import { getTokenUser } from '@/api/base'
import GoodItem from './GoodItem'
import CouponCell from '@/components/CouponCell'
import CityPicker from '@/components/CityPicker'
import {
  getAutoWrapContent,
  getPriceCreditHtml,
  formatDateTime
} from '@/utils/utils'
import { share } from '@/utils/share'

export default {
  name: 'OrderConfirm',
  components: { GoodItem, CouponCell, CityPicker },
  metaInfo: { title: '确认订单' },
  data() {
    return {
      is_redirect: false, // 是否重定向
      redirect_uri: '', // 重定向地址
      redirect_urii: '',
      typevip: '',
      orderType: '', // 订单类型
      orderParam: {
        userRelaCouponId: '',
        addressId: '',
        sourceUrl: '',
        param: {}
      }, // 订单参数
      detail: {}, // 所有数据
      order: {}, // 订单数据
      coupon: [], // 优惠券
      address: {}, // 收货地址
      list: [
        { label: '商品金额：', value: 'tradeInfo.goodAmount', before: '¥' },
        { label: '运费', value: 'tradeInfo.freightAmount', before: '¥' },
        {
          label: '优惠金额：',
          value: 'tradeInfo.tradeDiscount',
          before: '-¥'
        },
        {
          label: '实付：',
          value: 'tradeInfo.payAmount',
          className: 'price',
          // before: '¥',
          computed(value, order) {
            let payAmount = order.tradeInfo.payAmount
            let creditAmount = order.tradeInfo.creditAmount
            let result = ''
            if (payAmount || !creditAmount) {
              result += `¥${payAmount}`
            }
            if (payAmount && creditAmount) {
              result += `+`
            }
            if (creditAmount) {
              result += `${creditAmount}积分`
            }
            return result
          }
        }
      ],
      form: {},
      ruleForm: [],
      disabled: false,
      isFocus: false,
      userInfo: null,
      currentPickerName: '', // 当前操作的pickername
      picker: {}
    }
  },
  computed: {
    startDate() {
      let year = new Date().getFullYear()
      // 100年前
      return new Date(year - 100, 0, 1)
    },
    endDate() {
      let year = new Date().getFullYear()
      // 100年后
      return new Date(year + 100, 11, 31)
    }
  },
  methods: {
    get,
    getAutoWrapContent,
    getPriceCreditHtml,
    formatDateTime,
    // 获取用户信息
    getUser() {
      getTokenUser().then(response => {
        this.userInfo = response.data
      })
    },
    // 订单初始化
    initOrder() {
      if (this.orderType === '2') {
        // 商城
        this.initShopOrder()
      } else {
        // 票
        this.initTicketOrder()
      }
    },
    // 计算订单
    calculateOrder() {
      if (this.orderType === '2') {
        // 商城
        this.calculateShopOrder()
      } else {
        // 票
        this.calculateTicketOrder()
      }
    },
    // 创建订单
    createOrder() {
      if (this.orderType === '2') {
        // 商城
        this.createShopOrder()
      } else {
        // 票
        this.createTicketOrder()
      }
    },
    // change优惠券
    couponChange() {
      if (this.orderType === '2') {
        // 商城
        this.calculateShopOrder()
      } else {
        // 票
        this.calculateTicketOrder()
      }
    },
    // 初始化售票订单
    initTicketOrder() {
      initTicketOrder(this.orderParam).then(response => {
        let data = response.data
        this.detail = Object.assign({}, this.detail, data)
        this.order = Object.assign({}, this.order, data.order)
        this.coupon = data.coupon || []
        this.orderParam.userRelaCouponId = this.order.tradeInfo.userRelaCouponId
        // 收货地址
        this.address = Object.assign({}, this.address, data.address)
        this.orderParam.addressId = this.address ? this.address.id : ''
        // 取票信息
        this.ruleForm = (data.pickTickInfo && data.pickTickInfo.inputs) || []
        // 设置默认选中
        this.ruleForm.forEach(item => {
          // select
          if (item.inputType === 2 && item.values && item.values.length) {
            this.form[item.key] = item.values[0].value
          }
          // date
          if (item.inputType === 4) {
            this.$set(this.form, item.key, +new Date())
            this.picker[item.key] = new Date()
          }
        })
      })
    },
    // 计算售票订单
    calculateTicketOrder() {
      calculateTicketOrder(this.orderParam).then(response => {
        this.order = Object.assign({}, this.order, response.data)
      })
    },
    // 创建售票订单
    createTicketOrder() {
      let param = Object.assign({}, this.orderParam)
      Object.assign(param.param, this.form)
      this.disabled = true
      createTicketOrder(param)
        .then(response => {
          this.createOrderSuccess(response.data)
        })
        .catch(response => {
          this.disabled = false
        })
    },
    // 初始化商城订单
    initShopOrder() {
      initShopOrder(this.orderParam).then(response => {
        let data = response.data
        // 详情所有数据
        this.detail = Object.assign({}, this.detail, data)
        // 订单数据
        this.order = Object.assign({}, this.order, data.order)
        // 优惠券
        this.coupon = data.coupon || []
        this.orderParam.userRelaCouponId = this.order.tradeInfo.userRelaCouponId
        // 收货地址
        this.address = Object.assign({}, this.address, data.address)
        this.orderParam.addressId = this.address ? this.address.id : ''
        // 取票信息
        this.ruleForm = (data.pickTickInfo && data.pickTickInfo.inputs) || []
        // 设置默认选中
        this.ruleForm.forEach(item => {
          // select
          if (item.inputType === 2 && item.values && item.values.length) {
            this.form[item.key] = item.values[0].value
          }
          // date
          if (item.inputType === 4) {
            this.$set(this.form, item.key, +new Date())
            this.picker[item.key] = new Date()
          }
        })
      })
    },
    // 计算商城订单
    calculateShopOrder() {
      calculateShopOrder(this.orderParam).then(response => {
        this.order = Object.assign({}, this.order, response.data)
      })
    },
    // 创建商城订单
    createShopOrder() {
      let param = Object.assign({}, this.orderParam)
      console.log(param)
      Object.assign(param.param, this.form)
      this.disabled = true
      createShopOrder(param)
        .then(response => {
          this.createOrderSuccess(response.data)
        })
        .catch(response => {
          this.disabled = false
        })
    },
    // 订单创建成功
    createOrderSuccess(data) {
      console.log('走在这里')
      this.disabled = false
      if (data.tradeInfo.payState === 'SUCCESS') {
        // 订单状态成功直接进入详情页
        if (this.is_redirect) {
          pageUrl = `${process.env.VUE_APP_WEBAPP_PAY_URL}/?trade_id=${
            data.tradeInfo.id
          }&open_id=${data.buyer.openIdStr}&redirect_uri=${encodeURIComponent(
            this.redirect_uri
          )}&is_redirect=${this.is_redirect}`
          location.href = `${this.redirect_uri}`
        } else {
          this.$router.replace(`/my/order/item/${data.tradeInfo.id}`)
        }
      } else {
        let pageUrl
        pageUrl = `${process.env.VUE_APP_WEBAPP_PAY_URL}/?trade_id=${
          data.tradeInfo.id
        }&open_id=${data.buyer.openIdStr}&redirect_uri=${encodeURIComponent(
          this.redirect_uri
        )}&is_redirect=${this.is_redirect}`

        location.href = pageUrl
      }
    },
    onAddress() {
      if (this.address && this.address.name) {
        this.$router.push('/my/address')
      } else {
        this.$router.push('/my/address/add')
      }
    },
    onSubmit() {
      if (this.userInfo && this.userInfo.phone) {
        this.checkForm() && this.createOrder()
      } else {
        this.$router.push({
          path: '/login',
          query: {
            logout: +new Date(),
            required_phone: '1',
            redirect_uri: location.href
          }
        })
      }
    },
    // 表单校验
    checkForm() {
      // 是否为空
      function isEmpty(value) {
        if (!value) {
          return true
        } else {
          return false
        }
      }
      // 是否为手机号
      function isPhoneNumber(value) {
        if (/^[0-9]*$/g.test(value)) {
          return true
        } else {
          return false
        }
      }
      for (let i = 0; i < this.ruleForm.length; i++) {
        let item = this.ruleForm[i]
        if (item.allowBlank === 0) {
          if (isEmpty(this.form[item.key])) {
            this.$toast(item.hint || '请输入' + item.keyName)
            return false
          }
        }
        if (item.verifyType === 1 && !isPhoneNumber(this.form[item.key])) {
          this.$toast('请输入正确的手机号码')
          return false
        }
      }
      return true
    },
    // 表单聚焦
    inputFocus() {
      this.isFocus = true
    },
    // 表单失去焦点
    inputBlur() {
      this.isFocus = false
    },
    openPicker(refName) {
      this.currentPickerName = refName
      this.$refs[refName][0].open()
    },
    // 日期确定
    onPickerConfirm(value) {
      this.form[this.currentPickerName] = +new Date(value)
    },
    // 城市确定
    onCityConfirm(value) {
      let [province, city, area = {}] = value
      this.$set(this.form, this.currentPickerName, {
        provinceId: province.id,
        province: province.name,
        cityId: city.id,
        city: city.name,
        districtId: area.id || '',
        district: area.name || ''
      })
    }
  },
  created() {
    let query = this.$route.query
    if (query) {
      if (typeof query.is_redirect === 'boolean') {
        this.is_redirect = query.is_redirect
      } else {
        this.is_redirect = query.is_redirect === 'true'
      }

      this.redirect_uri = query.redirect_uri
      this.redirect_urii = query.redirect_urii
      console.log(query)
      this.typevip = query.typevip
      this.orderType = query.order_type
      this.orderParam.sourceUrl = this.redirect_uri

      try {
        this.orderParam = Object.assign(
          {},
          this.orderParam,
          JSON.parse(query.order_param)
        )
        this.initOrder()
      } catch (error) {
        console.log(error)
      }
    }
    this.getUser()
    // 分享语设置
    share({
      title: '在艺App',
      desc: '爱艺术的人都在这里',
      link: 'https://www.zai-art.com',
      imgUrl: 'https://img.zai-art.com/logo/512.png'
    })
  }
}
</script>
<style src='@/assets/css/order.css'></style>
